
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">اضافة طريقة التبرع</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form [formGroup]="insertForm" (ngSubmit)="Submit()">

                    <div class="row m-0 mb-2">
                        <div class="col-md-6">
                          <label for=""> الاسم 
                          </label>
                            <div class="form-group">
                                
                               <input type="text"  class="form-control"  formControlName="TitleAr" 
                               [tooltip]="fc.TitleAr.errors?.required ? ' الاسم مطلوب' : null" required
                               [isDisabled]="!((fc.TitleAr.errors?.required && fc.TitleAr.touched))"
                               containerClass="" [class.is-valid]="fc.TitleAr.valid && (fc.TitleAr.touched)"
                               [class.is-invalid]="fc.TitleAr.invalid && (fc.TitleAr.touched)"
                               >
                            </div>
                        </div>
                        <!-- <div class="col-md-4">
                          <label for=""> اسم المشروع باللغة الانجليزية
                          </label>
                            <div class="form-group">
                                
                               <input type="text"  class="form-control" appDisableWeritingArabic formControlName="Title" 
                               [tooltip]="fc.Title.errors?.required ? ' الاسم مطلوب' : null" required
                               [isDisabled]="!((fc.Title.errors?.required && fc.Title.touched))"
                               containerClass="" [class.is-valid]="fc.Title.valid && (fc.Title.touched)"
                               [class.is-invalid]="fc.Title.invalid && (fc.Title.touched)"
                               >
                            </div>
                        </div> -->
                        <div class="col-md-6">
                            <label for=""> الترتيب
                            </label>
                              <div class="form-group">
                                  
                                <input type="number"  class="form-control" formControlName="Order" 
                                [tooltip]="fc.Order.errors?.required ? ' الترتيب مطلوب' : null" required
                                [isDisabled]="!((fc.Order.errors?.required && fc.Order.touched))"
                                containerClass="" [class.is-valid]="fc.Order.valid && (fc.Order.touched)"
                                [class.is-invalid]="fc.Order.invalid && (fc.Order.touched)"
                                >
                              </div>
                          </div>
                       
                          <div class="col-md-6">
                            <label for=""> المبلغ
                            </label>
                              <div class="form-group">
                                  
                                 <input type="text" onlyNumbers class="form-control" formControlName="Amount" 
                                 [tooltip]="fc.Amount.errors?.required ? ' المبلغ مطلوب' : null" required
                                 [isDisabled]="!((fc.Amount.errors?.required && fc.Amount.touched))"
                                 containerClass="" [class.is-valid]="fc.Amount.valid && (fc.Amount.touched)"
                                 [class.is-invalid]="fc.Amount.invalid && (fc.Amount.touched)"
                                 >
                              </div>
                          </div>
                    
      <div class="col-md-6">
                            <label for="">   الوصف 
                            </label>
                              <div class="form-group">
                                  
                                 <textarea type="text"  style="height: 100px;"  class="form-control" formControlName="DescriptionAr" 
                                 [tooltip]="fc.DescriptionAr.errors?.required ? ' الوصف مطلوب' : null" required
                                 [isDisabled]="!((fc.DescriptionAr.errors?.required && fc.DescriptionAr.touched))"
                                 containerClass="" [class.is-valid]="fc.DescriptionAr.valid && (fc.DescriptionAr.touched)"
                                 [class.is-invalid]="fc.DescriptionAr.invalid && (fc.DescriptionAr.touched)"
                                 ></textarea>
                              </div>
                          </div>
                             <!-- <div class="col-md-6">
                            <label for="">   الوصف باللغه الانجليزية
                            </label>
                              <div class="form-group">
                                  
                                 <textarea type="text"  style="height: 100px;" appDisableWeritingArabic class="form-control" formControlName="Description" 
                                 [tooltip]="fc.Description.errors?.required ? ' الوصف مطلوب' : null" required
                                 [isDisabled]="!((fc.Description.errors?.required && fc.Description.touched))"
                                 containerClass="" [class.is-valid]="fc.Description.valid && (fc.Description.touched)"
                                 [class.is-invalid]="fc.Description.invalid && (fc.Description.touched)"
                                 ></textarea>
                              </div>
                          </div> -->
                         <!-- to insert image  -->
                         <div class="col-6 my-3 " >
                          <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                         <input type="file"  accept="image/*" #file id="getLogo"
                          style="display: none" (change)="getLogoUrl($event)" />
                      <button type="button" onclick="document.getElementById('getLogo').click()"
                          class="btn   d-block"  style="width: 60%;">
                          ارفاق صورة
                      </button>    
                                  </div>
                     
                        <div class="col-12 col-md-12">
                            <div   *ngIf="update; else elseBlock">
                                <button [disabled]="BtnDisaple"  class="btn  pull-right" type="submit" >
                                  تعديل
                                </button>
                              </div>
                  
                              <ng-template #elseBlock>
                                <button [disabled]="BtnDisaple"  class="btn  pull-right" type="submit">
                                  إضافة
                                </button>
                              </ng-template>
                </div>
                </div>
                    </form>
    </div>
</div>
        </div>
    </div>
</div>